import { render, staticRenderFns } from "./VehicleTab_rest.vue?vue&type=template&id=c59d62f8&scoped=true"
import script from "./VehicleTab_rest.vue?vue&type=script&lang=js"
export * from "./VehicleTab_rest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59d62f8",
  null
  
)

export default component.exports